import { cloneObject, wrap, round, makeEdge, makeNodeDot, makeInvisNode, makeInvisEdge } from "../utils/utils";
import { isEqual, isNull, isArray } from "lodash";
import JSZip from "jszip";


export const addProcess = (dsd, Data = {}, onAdd, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadProcess(Data)

    dsd.httpConfig.post(`/processes`, payload, headers)
        .then(response => {
            if (onAdd){
                onAdd(response.data._id)
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
}

export const editProcess = (dsd, id = null, Data = {}, onUpdate, onError) => {
    
    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }


    let payload = payloadProcess(Data)

    dsd.httpConfig.put(`/processes/${id}`, payload, headers)
        .then(response => {
            if (onUpdate){
                onUpdate();
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return true;
};

function payloadProcess(data){

    let payload = {}
    payload.name = data.name;
    payload.description = data.description;
    payload.proposals = data.proposals;
    payload.status = data.status;

    return payload;

}

function dataProcess(data){

    let Process = data;

    return Process;

}

export const getProcess = (dsd, id=null, onLoad=null, onFail=null, representation="dsd", format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/processes/${id}?`

        if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};

export const getProcessVersion = (dsd, id=null, idVersion = null, onLoad=null, onFail=null, representation='dsd', format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/processes/${id}/version/${idVersion}?`

    if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};

export const listProcesses = (dsd, Filters={}, onLoad, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/processes"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }
    
    if (Filters.idUser){
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.scope){
        urlAPI += `scope=${encodeURIComponent(Filters.scope)}&`;
    }

    if (Filters.status){
        urlAPI += `status=${encodeURIComponent(Filters.status)}&`;
    }

    if (Filters.search){
        urlAPI += `search=${encodeURIComponent(Filters.search)}&`;
    }

    if (Filters.idSubProcess){
        urlAPI += `idSubProcess=${encodeURIComponent(Filters.idSubProcess)}&`;
    }

    if (Filters.idArtefact){
        urlAPI += `idArtefact=${encodeURIComponent(Filters.idArtefact)}&`;
    }
    
    if (Filters.idResource){
        urlAPI += `idResource=${encodeURIComponent(Filters.idResource)}&`;
    }
    
    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {

            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
                arr.push(dataProcess(response.data[pos]));
            }
            if (onLoad){
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;

};


// Step functions

function payloadStep(data){
    let payload = {}
    payload.name = data.name;
    payload.type = data.type;
    payload.description = data.description;
    payload.organisation = data.organisation;
    payload.role = data.role;
    payload.multiinstance = data.multiinstance;
    payload.foreach = data.foreach;
    payload.idSubProcess = data.idSubProcess;
    payload.Options = data.Options;
    payload.Flows = data.Flows;
    payload.Artefacts = data.Artefacts;
    payload.Resources = data.Resources;
    return payload;
}

function makeStepData(data){
    let Step = data;
    return Step;
}

export const addStepToProcess = (dsd, idProcess, Data = {}, onAdd, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadStep(Data);

    dsd.httpConfig.post(`/processes/${idProcess}/steps`, payload, headers)
        .then(response => {
            if (onAdd){
                onAdd(response.data._id)
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
};

export const editStep = (dsd, idProcess, id, Data = {}, onUpdate, onError) => {
    
    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadStep(Data);

    dsd.httpConfig.put(`/processes/${idProcess}/steps/${id}`, payload, headers)
        .then(response => {
            if (onUpdate){
                onUpdate();
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
};

export const deleteStep = (dsd, idProcess, id, onDelete, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    dsd.httpConfig.delete(`/processes/${idProcess}/steps/${id}`, headers)
        .then(response => {
            if (onDelete){
                onDelete();
            }
        })
        .catch(errorResponse => {
            if (errorResponse.code === "ERR_NETWORK") {
                onError({status: 'denied'});
            } else {
                if (errorResponse.response && errorResponse.response.status >= 400 && errorResponse.response.status < 500){
                    onError({status: 'error', errorMessage: errorResponse.response.data});
                } else {
                    onError({status: 'error', errorMessage: errorResponse.message});
                }
            }
        });

    return;
};

export const getStep = (dsd, id=null, onLoad=null, onFail=null, representation="dsd", format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/steps/${id}?`

        if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};


export const listSteps = (dsd, Filters={}, onLoad, onError) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();
    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/steps"
    if (Object.keys(Filters).length > 0){
        urlAPI += "?"
    }
    
    if (Filters.idUser){
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.idProcess){
        urlAPI += `idProcess=${encodeURIComponent(Filters.idProcess)}&`;
    }

    if (Filters.type){
        urlAPI += `type=${encodeURIComponent(Filters.type)}&`;
    }
    
    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {

            let arr = [];
            for (let pos=0; pos<response.data.length;pos++){
                arr.push(makeStepData(response.data[pos]));
            }
            if (onLoad){
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError){
                onError(e)
            }
        });

    return;
};


// ====== Process Visualization Helper Functions ======

export const makeStepNode = (Step, idNode) => {
    let Node = {};

    Node.type = 'step';
    Node.Step = Step;
    if (idNode){
        Node.idNode = idNode;
    }
    else {
        Node.idNode = `step_${Step._id}`;
    }

    Node.Edges = [];

    Node.color = "lightblue";
    Node.style = "filled,rounded";

    Node.height= "0.7";
    Node.width= "2";

    let LabelLength = 200;
    let LineLength = 30


    Node.shape = "rect";
    switch (Node.Step.type){
        case 'subprocess':
            Node.style = "filled,dotted";
            Node.color = "lightgrey";
            break;
        case 'decision':
        case 'choices':
            Node.shape = "diamond";
            break;
        case 'stop':
            Node.shape = "circle";
            Node.color = "red";
            Node.height= "0.5";
            Node.width= "0.5";

            LabelLength = 30;
            LineLength = 12;
            break;
    }


    Node.label = Node.Step.name;


    if (Node.label){
        if (Node.label.length > LabelLength){
            Node.label = Node.label.substring(1, LabelLength) + '...';
        }
    }

    Node.label = wrap(Node.label,LineLength,'\n');

    let StepIcon = '';

    if (Node.Step.multiinstance){
        StepIcon += "|||";
    }
    if (Node.Step.type == 'subprocess'){
        StepIcon += "+";
    }

    if (StepIcon){
        Node.label += `\n\n${StepIcon}`
    }

    return Node;
};

export const makeArtefactNode = (StepArtefact, seq=0) => {
    let Node = {};

    Node.type = 'artefact';
    Node.idArtefact = StepArtefact.idArtefact;
    Node.Artefact={};
    Node.idNode = `artefact_${Node.idArtefact}_${seq}`;
    Node.Edges = [];

    Node.Artefact = null;

    if (StepArtefact.Artefact){
        Node.Artefact = StepArtefact.Artefact;
    }

    Node.shape = "folder";

    if (Node.Artefact){
        switch (Node.Artefact.type){
            case 'document':
                Node.shape = "note";
                break;
            case 'datastore':
                Node.shape = "cylinder";
                break;
        }
    }

    Node.height= "0.7";
    Node.width= "0.7";


    Node.color = "grey";
    Node.style = "filled";

    Node.label = Node.idArtefact;
    if ("name" in Node.Artefact){
        Node.label = Node.Artefact.name;
    }

    if (Node.label){
        if (Node.label.length > 200){
            Node.label = Node.label.substring(1, 200);
        }
    }

    let LineLength = 12;
    Node.label = wrap(Node.label,LineLength,'\n');

    return Node;
};

export const makeArtefactEdge = (FromNode, ToNode, Use) => {
    let dotEdge = {}
    dotEdge.FromNode = FromNode;
    dotEdge.ToNode = ToNode;
    dotEdge.Label = "";
    if (isNull(dotEdge.Label)){
        dotEdge.Label = "";
    }

    let dir = 'none';
    switch (Use){
        case 'input':
            dir='back';
            break;
        case 'output':
            dir='forward';
            break;
        case 'update':
            dir='both';
            break;
    }


    dotEdge.dot = `${FromNode.idNode} -> ${ToNode.idNode} [label="${dotEdge.Label}" style="dashed", dir=${dir}];
    `;

    return dotEdge;
};

export const makeStartNode = () => {
    let Node = {};

    Node.type = 'start';
    Node.seqStep = null;
    Node.Step = null;
    Node.idNode = "start";
    Node.Edges = [];

    Node.height= "0.5";
    Node.width= "0.5";

    Node.Rank = 1;
    Node.Lane = 1;
    Node.Parallel = 1;

    Node.shape = "circle";
    Node.color = "green";
    Node.style = "filled";

    Node.label = "start";

    return Node;
};

export const makeStopNode = (Rank, Lane, Parallel) => {
    let Node = {};

    Node.type = 'stop';
    Node.seqStep = null;
    Node.Step = null;
    Node.idNode = `stop_${Rank}_${Lane}_${Parallel}`;
    Node.Edges = [];

    Node.Rank = Rank;
    Node.Lane = Lane;
    Node.Parallel = Parallel;

    Node.height= "0.5";
    Node.width= "0.5";

    Node.shape = "circle";
    Node.color = "red";
    Node.style = "filled";

    Node.label = "end";

    return Node;
};

export const makeArtefactParallel = (seqLane, seqParallel, dotNodes, dotLanes) => {
    // shift other parallels to make room

    for (let idNode in dotNodes){
        let dotNode = dotNodes[idNode];
        if (dotNode.Lane == seqLane){
            if (Number(dotNode.Parallel) >= Number(seqParallel)){
                dotNode.Parallel++;
            }
        }
    }

    let newParallels = {};
    for (const [key, dotLane] of Object.entries(dotLanes[seqLane].Parallels)) {
        if (Number(key) < Number(seqParallel)){
            newParallels[key] = dotLane;
        }
        if (Number(key) >= Number(seqParallel)){
            newParallels[Number(key)+1] = dotLane;
        }
    }
    newParallels[seqParallel] = {type:'artefact'};
    dotLanes[seqLane].Parallels = newParallels;
    dotLanes[seqLane].maxParallels++;
};

export const makeSwimlaneDot = (seq, Lane, maxRanks, dotLanes) => {
    let posX = 0;
    let posY = 0;

    posY = ( maxRanks );
    posY = posY * 1.2;

    for (let posLane=1; posLane<seq+1; posLane++){
        if (posLane in dotLanes){
            posX += Number(dotLanes[posLane].maxParallels);
        }
    }
    posX = (posX * 2.5) - 1.2;

    posX = round(posX,2);
    posY = round(posY,2);

    let idTop = `lane_${seq}_top`;
    let idBottom = `lane_${seq}_bottom`;

    let dot = '';

    dot += `
        ${idTop} [pos="${posX},${posY}!", height=0.1, width=0.1, style=invis];`;
    dot += `
        ${idBottom} [pos="${posX},0!", height=0.1, width=0.1,style=invis];`;
    dot += `
        ${idTop} -> ${idBottom} [dir=none, penwidth=5, color=grey, weight=5];`;

    if (Lane.Header){
        let label = Lane.Header;

        if (label){
            if (label.length > 300){
                label = label.substring(1, 300) + '...';
            }
            label = wrap(label,40,'\\l') + '\\l';
        }

        let idHeader = `lane_${seq}_header`;
        dot += `
        ${idHeader} [pos="${posX-1.2},${posY-0.2}!", label="${label}", fontsize=10, height=0.0, width=0.0, shape=none];`;
    }

    return dot;
};

export const vizProcess = (Process, engine = "dot", boolSwimlanes = false, boolArtefacts = false) => {

    let dotNodes = {};
    let dotEdges = {};
    let dotStartNode = makeStartNode();

    dotNodes['start'] = dotStartNode;

// create Step Nodes        
    for (let posStep = 0; posStep < Process.Steps.length; posStep++ ){
        let Step = Process.Steps[posStep];
        let boolMakeStep = true;
        if (isNull(Step)){
            boolMakeStep = false;
        }else{
            if (isEqual(Step,{})){
                boolMakeStep = false;
            }
            if ( isNull(Step.name)){
                boolMakeStep = false;
            }
        }

        if (boolMakeStep){
            let idNode = `step_${Step._id}`
            dotNodes[idNode] = makeStepNode(Step, idNode);
        }
    };

// create Edges
    for (let posStep = 0; posStep < Process.Steps.length; posStep++ ){
        let Step = Process.Steps[posStep];

        let ToNodeId = `step_${Step._id}`;
        if (ToNodeId in dotNodes){

            let ToStepNode = dotNodes[ToNodeId];

            if (ToStepNode){
                let boolHasFlow = false;
                let boolFlowStart = false;
//                    if ("Flows" in Step){
                if (Step.Flows){
                    for (let posFlow=0; posFlow<Step.Flows.length; posFlow++){
                        let Flow = Step.Flows[posFlow];

                        if (Flow.idStep){

                            let FromNodeId = `step_${Flow.idStep}`;
                            if (FromNodeId in dotNodes){
                                let FromStepNode = dotNodes[FromNodeId];
            
                                if (FromStepNode){
                                    boolHasFlow = true;
                                    let Label = null;
                                    let seqOption = 0;
                                    if (Flow.idOption){
                                        if (FromStepNode.Step.Options){
                                            for (let posOption=0; posOption<FromStepNode.Step.Options.length;posOption++){
                                                let Option = FromStepNode.Step.Options[posOption];
                                                seqOption = posOption+1;
                                                if (Option._id == Flow.idOption){
                                                    Label = Option.label;
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                    let dotEdge = makeEdge(Label ,FromStepNode, ToStepNode);
                                    dotEdge.seqOption = seqOption;

        // put the edge into the From Node Edge Array, in the order that the Option is defined - so that the 1st parallel is the 'happy path'

                                    let arrNodeEdges = [];
                                    let boolFlowInserted = false;
                                    for (let posEdge=0; posEdge<FromStepNode.Edges.length; posEdge++){
                                        if (!boolFlowInserted){
                                            if (FromStepNode.Edges[posEdge].seqOption > seqOption){
                                                boolFlowInserted = true;
                                                arrNodeEdges.push(dotEdge);
                                            }
                                        }
                                        arrNodeEdges.push(FromStepNode.Edges[posEdge]);
                                    }
                                    if (!boolFlowInserted){
                                        boolFlowInserted = true;
                                        arrNodeEdges.push(dotEdge);
                                    }

                                    FromStepNode.Edges = arrNodeEdges;

                                    dotEdges[`flow_${Flow._id}`] = dotEdge;
                                }        
                            }
                        }
                        else{
// a Flow with no idStep is a Flow from the Start
                            boolFlowStart = true;
                        }
                    }
                };

                if (!boolHasFlow){
                    boolFlowStart = true;
                }
                if (boolFlowStart){
                    let dotEdge = makeEdge("" ,dotStartNode, ToStepNode);
                    dotStartNode.Edges.push(dotEdge);
                    let idEdge = 'start_'+dotStartNode.Edges.length;
                    dotEdges[idEdge] = dotEdge;
                }

            }
        }
    }


// put nodes into Pools, Lanes        

    let LaneNames = {}
    let dotLanes = {};


    for (let idNode in dotNodes){
        let dotNode = dotNodes[idNode];
// find start nodes ( those with no Flows , or with a Flow with no Steo)
        if (dotNode.Step){

            let boolStartNode = false;

            let boolHasFlow = false;
            let boolFlowStart = false;

            if (dotNode.Step.Flows){
                for (let posFlow = 0; posFlow<dotNode.Step.Flows.length; posFlow++){
                    if (!isNull(dotNode.Step.Flows[posFlow])){
                        let Flow = dotNode.Step.Flows[posFlow]
                        if ("idStep" in Flow){
                            if (Flow.idStep){
                                boolHasFlow = true;
                            }
                            else{
                                boolFlowStart = true;
                            }
                        }
                        else{
                            boolFlowStart = true;
                        }
                    }
                }
            }
            if (!boolHasFlow){
                boolFlowStart = true;
            }
            if (boolFlowStart){
                boolStartNode = true;
            }
            if (boolStartNode){
                dotNode.Rank = 2;
                dotNode.Lane = 1;
                if (boolSwimlanes){
                    setLane(dotNode,LaneNames);
                    if (dotStartNode.Lane == 1){
                        dotStartNode.Lane = dotNode.Lane;
                    }
                }
                dotNode.Parallel = getNextParallel(1, dotNode.Lane, dotNode.Rank, dotNodes);
                setNextNodes(dotNode, dotNodes, dotEdges, LaneNames, boolSwimlanes);
            }
        }

    }

    for (let idNode in dotNodes){
        let dotNode = dotNodes[idNode];
        if (!(dotNode.Lane in dotLanes)){
            dotLanes[dotNode.Lane] = {maxParallels:0, Parallels:{}}
        }    
        if (dotNode.Parallel > dotLanes[dotNode.Lane].maxParallels){
            dotLanes[dotNode.Lane].maxParallels = dotNode.Parallel;
        }
        if (!(dotNode.Parallel in dotLanes[dotNode.Lane].Parallels)){
            dotLanes[dotNode.Lane].Parallels[dotNode.Parallel] = {type:"step"};
        }
    }

// set Lane Header

    for (let LaneName in LaneNames){
        let seqName = LaneNames[LaneName].seq;
        if (seqName in dotLanes){
            dotLanes[seqName].Header = LaneName;
        } 
    }

// artefacts
    if (boolArtefacts){
        for (let idNode in dotNodes){
            let dotNode = dotNodes[idNode];

            if (dotNode.type == 'step'){
                let StepNode = dotNode;

                if ("Artefacts" in StepNode.Step){
                    if (isArray(StepNode.Step.Artefacts)){
                        for (let posStepArtefact = 0; posStepArtefact < StepNode.Step.Artefacts.length; posStepArtefact++ ){
                            const StepArtefact = StepNode.Step.Artefacts[posStepArtefact];
//                                const idNode = `artefact_${StepArtefact.idArtefact}`;
                            let boolMakeArtefact = true;
                            let ArtefactNode = {};

                            let seqNextNode = 0;
                            for (let ArtefactNode in dotNodes){
                                if (ArtefactNode.type == 'artefact'){
                                    if (ArtefactNode.idArtefact == StepArtefact.idArtefact){
// duplicate artefacts if they are not within two ranks
                                        seqNextNode++;
                                        if (Math.abs((Number(StepNode.Rank) - Number(ArtefactNode.Rank))) < 2){
                                            boolMakeArtefact = false;
                                        }
                                    }
                                }
                            }

                            if (boolMakeArtefact){
                                ArtefactNode = makeArtefactNode(StepArtefact, seqNextNode);
    // ? has an artefact parallel been set up?
                                let seqArtefactParallel = StepNode.Parallel + 1;
                                let boolMakeArtefactParallel = true;
                                if (seqArtefactParallel in dotLanes[StepNode.Lane].Parallels){
                                    if (dotLanes[StepNode.Lane].Parallels[seqArtefactParallel].type == 'artefact'){
                                        boolMakeArtefactParallel = false;
                                    }
                                }
                                if (boolMakeArtefactParallel){
                                    makeArtefactParallel(StepNode.Lane, seqArtefactParallel, dotNodes, dotLanes);
                                }
// find unoccupied rank 
                                ArtefactNode.Rank = StepNode.Rank;
                                ArtefactNode.Lane = StepNode.Lane;
                                ArtefactNode.Parallel = seqArtefactParallel;
                                for (let checkNode in dotNodes){
                                    if (checkNode.Lane == ArtefactNode.Lane){
                                        if (checkNode.Parallel == ArtefactNode.Parallel){
                                            if (checkNode.Rank == ArtefactNode.Rank){
                                                ArtefactNode.Rank++;
                                            }
                                        }
                                    }
                                }
                                

                                if (ArtefactNode.Rank > StepNode.Rank){
                                    const fromRank = StepNode.Rank + 1;
                                    const numRanksToShift = ArtefactNode.Rank - StepNode.Rank
                                    for (let ShiftNode in dotNodes){
                                        if (ShiftNode.Rank >= fromRank){
                                            ShiftNode.Rank = ShiftNode.Rank + numRanksToShift;
                                        }
                                    }
                                }

                                dotNodes[ArtefactNode.idNode] = ArtefactNode;
                            }

                            let ArtefactEdge = makeArtefactEdge(StepNode, ArtefactNode, StepArtefact.use);
                            let idEdge = `artefact_${StepArtefact.idArtefact}_${StepNode.idNode}`;
                            dotEdges[idEdge] =  ArtefactEdge;
                        }
                    }
                }
            }
        };
    }

// add stop nodes

    for (let idNode in dotNodes){
        let dotNode = dotNodes[idNode];
        let boolAddStopNode = false;
        if (!("Edges" in dotNode)){
            boolAddStopNode = true;
        }else{
            if (dotNode.Edges.length == 0){
                boolAddStopNode = true;
            }
        }
        switch (dotNode.type){
            case "artefact":
            case "stop":
                boolAddStopNode = false;
                break;
            case 'step':
                if ("Step" in dotNode){
                    switch (dotNode.Step.type){
                        case 'stop':
                            boolAddStopNode = false;
                            break;
                    }
                }
                break;
        }

        if (boolAddStopNode){
            let StopNode = makeStopNode(dotNode.Rank + 1, dotNode.Lane, dotNode.Parallel); 
            dotNodes[StopNode.idNode] = StopNode;
            let StopEdge = makeEdge("",dotNode, StopNode );
            let idEdge = `stop_${dotNode.idNode}`
            dotEdges[idEdge] = StopEdge;
        }
    }



    let maxRanks = 0;
    let maxLanes = 0;
    for (let idNode in dotNodes){
        let dotNode = dotNodes[idNode];
        if (dotNode.Rank > maxRanks){
            maxRanks = dotNode.Rank;
        }
        if (dotNode.Lane > maxLanes){
            maxLanes = dotNode.Lane;
        }
    }



    let dot = '';

    let Key = {};

    dot += `
digraph  { 
    overlap=false; 
    splines=true; 
    node [ fixedsize=true, width=2, color=black, fillcolor=lightblue ,fontname="Arial", fontcolor=black, fontsize=7 ]; 
    edge [fontname="Arial", fontsize=7, labelfontname="Arial", labelfontsize=7, len=3.0];            
`

    if (boolSwimlanes){
        dot += `
    rankdir="LR"
`
        for (let seqLane in dotLanes){
            let dotLane = dotLanes[seqLane]
            dot += `
            ${makeSwimlaneDot(Number(seqLane), dotLane, maxRanks, dotLanes)}`;                                    
        }

    }

    let idNodes = {};

    let thisIdNode = null;
    for (let seqRank = 1; seqRank <= maxRanks; seqRank++){
        for (let seqLane = 1; seqLane <= maxLanes; seqLane++){
            if (seqLane in dotLanes){
                for (let seqParallel = 1; seqParallel <= dotLanes[seqLane].maxParallels; seqParallel++){
                    let boolFound = false;
                    for (let idNode in dotNodes){
                        let dotNode = dotNodes[idNode];
                        if (dotNode.Rank == seqRank){
                            if (dotNode.Lane == seqLane){
                                if (dotNode.Parallel == seqParallel){
                                    boolFound = true;
                                    idNodes[dotNode.idNode] = dotNode;
                                    dot += `
    ${makeNodeDot(dotNode, true, maxRanks, dotLanes)}`;                        
                                    thisIdNode = dotNode.idNode;
                                }
                            }
                        } 
                    }
                    if (engine == 'dot'){
                        if (!boolFound){
                            thisIdNode = `invis_${seqRank}_${seqLane}_${seqParallel}`;
                            dot += makeInvisNode(thisIdNode);
                        }

                        if ("idNode" in dotLanes[seqLane].Parallels[seqParallel]){
                            let idNodeFrom = dotLanes[seqLane].Parallels[seqParallel].idNode;
                            let idNodeTo = thisIdNode;

                            let boolInvisEdgeRequired = true;
                            for (let idEdge in dotEdges){
                                let dotEdge = dotEdges[idEdge];
                                if (dotEdge.FromNode.idNode == idNodeFrom){
                                    if (dotEdge.ToNode.idNode == idNodeTo){
                                        boolInvisEdgeRequired = false;
                                    }
                                }
                            }

                            if (boolInvisEdgeRequired){
                                dot += makeInvisEdge(idNodeFrom, idNodeTo);
                            }
                        }

                        dotLanes[seqLane].Parallels[seqParallel].idNode = thisIdNode;
                    }
                }
            }
        }

    }


// apply flow 

    dot += `

    `; 


    for (let idEdge in dotEdges){
        let dotEdge = dotEdges[idEdge];
// only output the endge if the Nodes have been output
        if (!(dotEdge.FromNode.idNode in idNodes)){
            continue;
        }
        if (!(dotEdge.ToNode.idNode in idNodes)){
            continue;
        }

        dot += `
    ${dotEdge.dot}`;
    }

    dot += `
}`; 

    return {"dot":dot,"nodes":dotNodes};

};

export const setNextNodes = (dotNode, dotNodes, dotEdges, LaneNames, boolSwimlanes) => {

    let boolHasNextNode = false;

    if ("Edges" in dotNode){            
        for (let posEdge = 0; posEdge<dotNode.Edges.length; posEdge++){
            let NextNode = dotNode.Edges[posEdge].ToNode;

            if (!(NextNode.Lane)){
                NextNode.Lane = 1;
                if (boolSwimlanes){
                    setLane(NextNode, LaneNames);
                }
            }

            boolHasNextNode = true;
            if (!("Rank" in NextNode)){
                NextNode.Rank = dotNode.Rank + 1;
                if (!("Lane" in NextNode)){
                    NextNode.Lane = 1;
                }
                let minParallel = 1;
                if (NextNode.Lane == dotNode.Lane){
                    if (dotNode.Parallel){
                        minParallel = dotNode.Parallel;
                    }
                }
                NextNode.Parallel = getNextParallel(minParallel, NextNode.Lane,NextNode.Rank, dotNodes);
                setNextNodes(NextNode, dotNodes, dotEdges, LaneNames, boolSwimlanes);
            }else{
                if (NextNode.Rank < dotNode.Rank){
                        if (!NodesConnected(NextNode, dotNode, dotNodes)){
                        NextNode.Rank = dotNode.Rank + 1;
                        shiftConnectedNodes(NextNode, dotNodes);
                        }
                }
            }
        }
    }
};

export const setLane = (dotNode, LaneNames) => {
    let seqLane = Object.keys(LaneNames).length + 2;

    dotNode.Lane = 1;
    if ('Step' in dotNode){
        if (dotNode.Step){
            let LaneName = '';
            if ('organisation' in dotNode.Step){
                LaneName += dotNode.Step.organisation;
            }
            if ('role' in dotNode.Step){
                if (LaneName.length > 0){
                    LaneName += '/';
                }
                LaneName += dotNode.Step.role;
            }
            if (LaneName){
                if (!(LaneName in LaneNames)){
                    LaneNames[LaneName] = {}
                    LaneNames[LaneName].seq = seqLane;
                }
                dotNode.Lane = LaneNames[LaneName].seq;
            }
        }
    }
};

export const getNextParallel = (min, Lane, Rank, dotNodes) => {
    let NextParallel = min;

    for (let idNode in dotNodes){
        let dotNode = dotNodes[idNode];
        if (dotNode.Lane == Lane){
            if (dotNode.Rank == Rank){
                if (dotNode.Parallel >= NextParallel){
                    NextParallel = dotNode.Parallel + 1;
                }
            }
        }
    }

    return NextParallel;
};

export const NodesConnected = (FromNode, ToNode, dotNodes, CheckedNodes={}) => {
    if (FromNode.idNode in CheckedNodes){
        return false;
    }

    CheckedNodes[FromNode.idNode] = true;

    if ("Edges" in FromNode){            
        for (let posEdge = 0; posEdge<FromNode.Edges.length; posEdge++){
            let checkEdge = FromNode.Edges[posEdge];
            if (isEqual(checkEdge.ToNode,ToNode)){
                return true;
            }
            if (NodesConnected(checkEdge.ToNode, ToNode, dotNodes, CheckedNodes)){
                return true;
            }
        }
    }

    return false;
};

export const shiftConnectedNodes = (dotNode, dotNodes, ShiftedNodes={}) => {
    if (dotNode.idNode in ShiftedNodes){
        return
    }

    ShiftedNodes[dotNode.idNode] = true;

    if ("Edges" in dotNode){            
        for (let posEdge = 0; posEdge<dotNode.Edges.length; posEdge++){
            let NextNode = dotNode.Edges[posEdge].ToNode;
            if ("Rank" in NextNode){
                if (NextNode.Rank <= dotNode.Rank){
                    NextNode.Rank = dotNode.Rank + 1;
                    shiftConnectedNodes(NextNode,dotNodes, ShiftedNodes);
                }
            }
        }
    }
    return;
};

export const zipProcess = async function(dsd, Process){

    const zip = new JSZip();

    let Promises = [];

    let Version = null;
    let idVersion = null;
    if (Process.Version){
        Version = Process.Version;
        idVersion = Version._id;
    }

    let nameFolder = `process_${Process._id}_version_${Version._id}`;

    let strProcess = JSON.stringify(Process, null, 4);
    zip.file(`${nameFolder}/dsd.json`, strProcess);

    let bpmn = null;
    let mermaid = null;
    let xpdl = null;
    let dot = null;
    let dotSwimlanes = null;
    let svg = null;
    let svgSwimlanes = null;

    const onDoneBpmn = function(reply){
        bpmn = reply;
        return;
    };

    const onDoneMermaid = function(reply){
        mermaid = reply;
        return;
    };

    const onDoneXpdl = function(reply){
        xpdl = reply;
        return;
    };

    const onDoneDot = function(reply){
        dot = reply;
        return;
    };

    const onDoneDotSwimlanes = function(reply){
        dotSwimlanes = reply;
        return;
    };

    const onDoneSvg = function(reply){
        svg = reply;
        return;
    };

    const onDoneSvgSwimlanes = function(reply){
        svgSwimlanes = reply;
        return;
    };


//    Promises.push(getProcessVersion(dsd,Process._id,idVersion, onDoneBpmn, null,'bpmn'));
    Promises.push(getProcessVersion(dsd,Process._id,idVersion, onDoneMermaid, null,'mermaid'));
    Promises.push(getProcessVersion(dsd,Process._id,idVersion, onDoneXpdl, null,'xpdl'));
    Promises.push(getProcessVersion(dsd,Process._id,idVersion, onDoneDot, null,'dot',null,{vizSwimlanes:false, vizArtefacts:true}));
    Promises.push(getProcessVersion(dsd,Process._id,idVersion, onDoneDotSwimlanes, null,'dot',null,{vizSwimlanes:true, vizArtefacts:true}));
    Promises.push(getProcessVersion(dsd,Process._id,idVersion, onDoneSvg, null,'image','svg',{vizSwimlanes:false, vizArtefacts:true}));
    Promises.push(getProcessVersion(dsd,Process._id,idVersion, onDoneSvgSwimlanes, null,'image','svg',{vizSwimlanes:true, vizArtefacts:true}));

    return(
        Promise.all(Promises)
        .then(async response => {
            if (bpmn){
                zip.file(`${nameFolder}/process.bpmn`, bpmn);
            }
            if (mermaid){
                zip.file(`${nameFolder}/mermaid.mmd`, mermaid);
            }
            if (xpdl){
                zip.file(`${nameFolder}/process.xpdl`, xpdl);
            }
            if (dot){
                zip.file(`${nameFolder}/viz.dot`,dot);
            }
            if (dotSwimlanes){
                zip.file(`${nameFolder}/viz_swimlanes.dot`,dotSwimlanes);
            }
            if (svg){
                zip.file(`${nameFolder}/image.svg`,svg);
            }
            if (svgSwimlanes){
                zip.file(`${nameFolder}/image_swimlanes.svg`,svgSwimlanes);
            }

            const zipData = await zip.generateAsync({
                type: "blob",
                streamFiles: true,
            })

            return zipData;

        })
    )


};
